import { Component, inject, OnInit, signal } from '@angular/core';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { ThemeName } from '@venecia/models';
import { I18nService, Language, LanguageService, ThemeService } from '@venecia/services';

@Component({
  selector: 'app-topbar-dropdown',
  imports: [TranslateModule, NgbDropdownModule],
  templateUrl: './topbar-dropdown.html',
  styleUrl: './topbar-dropdown.scss',
})
export class TopbarDropdown {
  readonly themeService = inject(ThemeService);

  private readonly i18nService = inject(I18nService);
  private readonly languageService = inject(LanguageService);

  protected readonly theme = signal<ThemeName>('light');
  protected readonly currentLang = signal<string | undefined>(undefined);
  protected readonly supportedLanguages = signal<Language[]>([]);
  protected readonly languageMenuOpen = signal(false);

  constructor() {
    this.theme.set(this.themeService.get());
    this.supportedLanguages.set(this.languageService.getSupportedLanguages());
    this.languageService.currentLanguage$
      .subscribe(langCode => {
        this.currentLang.set(langCode);
      });
  }

  toggleTheme(): void {
    this.themeService.toggle();
    this.theme.set(this.themeService.get());
  }

  toggleLanguageMenu(): void {
    this.languageMenuOpen.update((value) => !value);
  }

  changeLang(langCode: string): void {
    if (langCode === this.currentLang()) {
      return;
    }

    this.i18nService.changeLanguage(langCode);
    this.currentLang.set(langCode);
    this.languageMenuOpen.set(false);
  }

  isCurrentLang(langCode: string): boolean {
    return this.currentLang() === langCode;
  }

  currentLanguageLabel(): string {
    return this.supportedLanguages()
      .find((language) => language.code === this.currentLang())
      ?.label ?? this.currentLang() ?? 'Language';
  }
}